import React, {useEffect, useState} from 'react';
import apiBack from "../../utils/apiBack";
import NewsCard from "../../components/NewsCard";
import api from "../../utils/api";
import UseTranslations from "../../utils/useTranslations";

News.layout = "UserLayout";

export default function News({ newsData }) {
    const { locale, t } = UseTranslations();
    const [pageIndex, setPageIndex] = useState(1);
    const [maxPage, setMaxPage] = useState(newsData?.maxPage);
    const [data, setData] = useState(newsData?.data || []);

    useEffect(() => {
        setData(newsData?.data || []);
        setMaxPage(newsData?.maxPage);
    }, [newsData]);

    const handlePageChange = async (newPageIndex) => {
        setPageIndex(newPageIndex);
        try {
            const response = await api.get('news', { params: { page: newPageIndex } });
            setData(response.data.data);
            setMaxPage(response.data.maxPage);
        } catch (err) {
            console.error('Error fetching news:', err);
        }
    };

    const pages = () => {
        const pageNumbers = [];
        for (let i = 1; i <= maxPage; i++) {
            pageNumbers.push(
                <li className={`page-item ${pageIndex === i ? 'active' : ''}`} key={i}>
                    <a className="page-link" onClick={() => handlePageChange(i)}>{i}</a>
                </li>
            );
        }
        return pageNumbers;
    };

    return (
        <div className={"news-page"}>
            <div className="news-container">
                {data.map((news) => (
                    <NewsCard key={news.id} news={news} locale={locale}/>
                ))}
            </div>
            <nav aria-label="Page navigation example">
                {maxPage &&
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${pageIndex <= 1 ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={pageIndex <= 1} onClick={() => handlePageChange(pageIndex - 1)}>{t('prev')}</button>
                        </li>
                        {pages()}
                        <li className={`page-item ${pageIndex >= maxPage ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={pageIndex >= maxPage} onClick={() => handlePageChange(pageIndex + 1)}>{t('next')}</button>
                        </li>
                    </ul>
                }
            </nav>
        </div>
    );
}

export async function getServerSideProps({ query }) {
    let data;
    const pageIndex = query.page || 1;
    try {
        data = (await apiBack.get('news', { params: { page: pageIndex } })).data;
    } catch (err) {
        console.log(err);
    }
    return {
        props: {
            newsData: data || { data: [], maxPage: 1 },
        },
    };
}
